import React from 'react';
import ImageSelect from '../../../element/imageselect';
import Title from '../../../element/title';
import clone from 'clone';
import url from '../../../urlhandler/urlHandlerActions';

const $ = jQuery;
const RE = REBUILDER;

class ImageSelectPreview extends React.Component {
  constructor(props) {
    super(props);
    this.handleTagValue = this.handleTagValue.bind(this);
    this.metakey = '_reactive_builder_' + this.props.shortcodeKey;

    this.state = {
      'values': [],
      'options': [],
      'toogle': false,
    };
    this.changeToogle = this.changeToogle.bind(this);
  }

  componentWillMount() {
    const block = clone(this.props.block);
    this.processData(block);
  }
  componentWillReceiveProps(nextprops) {
    const block = clone(nextprops.block);
    this.setState({ toogle: nextprops.dropdonwtoggle[nextprops.block['uid']] });
    this.processData(block);
  }
  processData(block) {
    this.helperData = clone(this.props.helperData);
    this.block = block;
    let options = [];
    let values = this.state.values;
    if (this.block.selectedDataType !== null) {
      // taxonomies
      if (this.block.selectedDataType === 'taxonomies' && this.helperData) {
        options = this.helperData.terms[this.block.selectedTaxonomy] ? this.helperData.terms[this.block.selectedTaxonomy].linear : [];
        this.searchType = 'taxonomies';
        this.searchItem = this.block.selectedTaxonomy;
        // url case
        if (this.props.urlData.hasOwnProperty(this.searchItem)) {
          if (this.state.values.length < 1) {
            values = $.isArray(this.props.urlData[this.searchItem]) ? this.props.urlData[this.searchItem] : [this.props.urlData[this.searchItem]];
          }
        } else {
          values = [];
        }
      }
    }
    options.map((item) => {
      for (const key in item.term_meta[0]) {
        if (item.term_meta[0].hasOwnProperty(key)) {
          item.image_url = item.term_meta[0][key].image_small_url;
        }
      }
    });
    options.map((item) => {
      item.isActive = false;
      if (this.block.selectedType === 'singleselect' && item.slug === values[0]) {
        item.isActive = true;
      }
    });
    if (this.block.selectedType === 'multiselect') {
      options.map((item) => {
        if (values.indexOf(item.slug) !== -1) {
          item.isActive = true;
        }
      });
    }
    this.setState({
      values, options,
    });
  }
  handleTagValue(e, tagItem) {
    e.preventDefault();
    const options = this.state.options;
    const values = [];
    if (this.props.block.selectedType === 'singleselect') {
      options.map((item) => {
        if (item.slug === tagItem.slug) {
          item.isActive = !item.isActive;
        } else {
          item.isActive = false;
        }
        if (item.isActive) values.push(item);
      });
    } else {
      options.map((item) => {
        if (item.slug === tagItem.slug) {
          item.isActive = !item.isActive;
        }
        if (item.isActive) values.push(item);
      });
    }
    this.setState({ 'values': _.pluck(values, 'slug') });
    url.push({
      'searchItem': this.searchItem,
      'searchType': this.searchType,
      'searchField': 'imageSelect',
      values,
    });
  }
  changeToogle() {
    const toogle = !this.state.toogle;
    this.setState({ toogle });
  }
  render() {
    const ifOpen = this.state.toogle ? 'active' : 'toggle-option';
    const HelperClass = this.state.toogle ? 'single-component' : '';
    return (<div>
      <Title
        title={this.props.block.title}
        subtitle={this.props.block.subtitle}
        toogle= {this.state.toogle}
        onToogle = {this.changeToogle}
        selectedToogleViewType = {'true'}
        dropdown = {true}
        field={this.props.block.uid}
      />
      <div className={HelperClass + ' ' + 'dropdown-template'}>
      {this.state.options !== undefined && this.state.options.length ? <div>
          <ImageSelect options={this.state.options} isOpenElement={ifOpen} onSelectImage={this.handleTagValue} />
        </div> : null}
      {this.state.options.length === 0 ?
        <div className="rq-no-attributes-found">
          <h3>{API.LANG.NO_ATTR_FOUND}</h3>
        </div> : ''}
      </div>
    </div>);
  }
}

ImageSelectPreview.propTypes = {
  'helperData': React.PropTypes.object,
  'urlData': React.PropTypes.object,
  'block': React.PropTypes.object,
  'shortcodeKey': React.PropTypes.number,
};

export default ImageSelectPreview;



// WEBPACK FOOTER //
// ./assets/src/frontend/preview/search/dropdown/imageselectdropdownpreview.js